module.exports = __webpack_public_path__ + "img/file.ccc20857.png";